import EmailConfirmation from '../containers/Confirmation/EmailConfirmation';
import map from 'lodash/map';
import NewPassword from '../containers/NewPassword/NewPassword';
import RecoverPassword from '../containers/Recovery/RecoverPassword';

export const routes = {

  EmailConfirmation: {
    exact: true,
    path: '/verify/:key',
    component: EmailConfirmation
  },
  NewPassword: {
    exact: true,
    path: '/reset_password/:key',
    component: NewPassword
  },
  RecoverPassword: {
    exact: true,
    path: '/recovery_password',
    component: RecoverPassword
  }
};


export const ROUTES = map(routes, (value) => value.path);

